export default "__VITE_ASSET__B2D6UPz9__"